import { tv } from "@ui/lib/tv";
import type { ReactNode } from "react";

const wizardStage = tv({
  slots: {
    root: "flex w-full flex-1 flex-col items-center justify-center gap-8 py-8 text-center lg:gap-10",
    illustration:
      "flex shrink-0 items-center justify-center [&_img]:h-32 [&_img]:w-auto [&_img]:object-contain [&_svg]:h-32 [&_svg]:w-auto",
    headings: "flex flex-col items-center gap-3",
    heading: "text-display-sm text-neutral-800 lg:text-display-md",
    helper: "max-w-prose text-lg text-secondary lg:text-xl",
    controls: "flex w-full flex-col items-center gap-4 text-left",
  },
});

export interface WizardStageProps {
  /** Optional illustration rendered above the heading. Use `<Illustration name="..." />`. */
  illustration?: ReactNode;
  heading: string;
  helper?: string;
  children: ReactNode;
}

/** Shape 1: single-purpose stage (set a value, choose between options).
 *  Illustration → heading → helper → controls. Vertically and horizontally centred. */
export function WizardStage({ illustration, heading, helper, children }: WizardStageProps) {
  const styles = wizardStage();

  return (
    <div className={styles.root()}>
      {illustration ? <div className={styles.illustration()}>{illustration}</div> : null}
      <div className={styles.headings()}>
        <h1 className={styles.heading()}>{heading}</h1>
        {helper ? <p className={styles.helper()}>{helper}</p> : null}
      </div>
      <div className={styles.controls()}>{children}</div>
    </div>
  );
}
